import { render, staticRenderFns } from "./QuickApprove.vue?vue&type=template&id=0a7afbc8&"
import script from "./QuickApprove.vue?vue&type=script&lang=js&"
export * from "./QuickApprove.vue?vue&type=script&lang=js&"
import style0 from "./QuickApprove.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports